import { Injectable } from "@angular/core";
import { getAnalytics } from "firebase/analytics";
import { collectionData, collection, addDoc, updateDoc, Firestore, setDoc, doc, deleteDoc, getDocs, CollectionReference } from '@angular/fire/firestore';
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { ToastController } from "@ionic/angular";
import { indexedDBLocalPersistence, initializeAuth, getAuth, Auth, signInAnonymously } from "@angular/fire/auth";
import { Capacitor } from "@capacitor/core";
import { getApp } from "@angular/fire/app";

@Injectable({
    providedIn: 'root'
  })
  export class FirebaseService {

    auth: Auth;
    collection: CollectionReference;

    constructor(private aFirestore: AngularFirestore, private toastCtrl: ToastController, private firestore: Firestore) {
      this.init();
    }

    init() {
      const app = getApp();
      this.collection = collection(this.firestore, 'spiritual_gifts_test_results');
    
      try {
        this.auth = getAuth(app);
      } catch (error) {
        if (Capacitor.isNativePlatform()) {
          this.auth = initializeAuth(app, {
            persistence: indexedDBLocalPersistence,
          });
        }
      }
    
      const currentUser = this.auth.currentUser;
      if (!currentUser) {
        signInAnonymously(this.auth)
          .then(() => {
            console.log('Signed in anonymously');
          })
          .catch((error) => {
            console.error('Anonymous sign-in failed', error);
          });
      } else {
        console.log('User already signed in:', currentUser.uid);
      }
    
      // Initialize analytics
      const analytics = getAnalytics(app);
    }

    getData() {
      return collectionData(this.collection);
    }

    getDoc(id: string) {
      const docRef = doc(this.firestore, `spiritual_gifts_test_results/${id}`);
      return docRef;
    }

    async deleteDocument(id: string) {
      try {
        const docRef = this.getDoc(id);
        await deleteDoc(docRef);
        await this.showToast('Deleted', 'primary');
        return true;
      } catch (error) {
        await this.showToast('Error', 'danger');
        return false;
      }
    } 

    async addDocument(formData: any) {
      try {
        await addDoc(this.collection, formData);
        await this.showToast('Success', 'primary');
        return true;
      } catch (error) {
        await this.showToast('Error', 'danger');
        return false;
      }
    }

    async updateDocument(id: string, table: string, seat: string) {
      try {
        const docRef = this.getDoc(id);
        await updateDoc(docRef, { table: table, seat_number: seat });
        await this.showToast('Updated', 'primary');
        return true;
      } catch (error) {
        await this.showToast('Error', 'danger');
        return false;
      }
    }

    async setDocument(data: any, id: string) {
      try {
        const docRef = this.getDoc(id);
        await setDoc(docRef, data);
        return true;
      } catch (error) {
        return false;
      }
    }

    private async showToast(header: string, color: string) {
      const toast = await this.toastCtrl.create({
        header,
        color,
        duration: 1200,
        position: 'middle'
      });
      await toast.present();
    }

    async onSubmit(formData: any) {
      // Submit the form data to Firebase Firestore
      return this.aFirestore.collection('spiritual_gifts_test_results').add(formData)
        .then(async () => {
          console.log('Form data submitted successfully');
          const toast = await this.toastCtrl.create({
            header: 'Success',
            color: 'primary',
            duration: 1200,
            position: 'middle'
          });
          await toast.present();
          return true;
        })
        .catch(async (error) => {
          console.error('Error submitting form data:', error);
          const toast = await this.toastCtrl.create({
            header: 'Error',
            color: 'danger',
            duration: 1200,
            position: 'middle'
          });
          await toast.present();
          return false;
        });
    }
  

  }